import type { MatrixSession } from '$lib/types';
import { SessionService } from '$lib/services/session.service';

class SessionStore {
	session = $state.raw<MatrixSession | undefined>(SessionService.getFallback());

	/** Re-reads the stored session. */
	init(): void {
		this.session = SessionService.getFallback();
	}

	/** @param session - freshly logged-in session to persist */
	set(session: MatrixSession): void {
		SessionService.setFallback(
			session.accessToken,
			session.deviceId,
			session.userId,
			session.baseUrl
		);
		this.session = session;
	}

	/** Forgets the stored session. */
	clear(): void {
		SessionService.removeFallback();
		this.session = undefined;
	}

	/** @param path - app path to return to after login */
	rememberAfterLoginPath(path: string): void {
		SessionService.setAfterLoginRedirect(path);
	}

	/** @returns the remembered app path, forgetting it in the process */
	takeAfterLoginPath(): string | undefined {
		const path = SessionService.getAfterLoginRedirect();
		SessionService.deleteAfterLoginRedirect();
		return path;
	}
}

export const sessionStore = new SessionStore();

export const getSession = (): MatrixSession | undefined => sessionStore.session;
